/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import {DEVICE_ID_COOKIE_NAME} from "./constants";

export function deviceCookieExists(): boolean {
    return document.cookie.includes(DEVICE_ID_COOKIE_NAME);
}